"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _configure = require("@/api/configure.js");
var _dictionary = require("@/config/dictionary");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'courtVedioSource',
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      statevalue: null,
      //状态值
      stateArr: [
      //状态数组
      {
        value: 0,
        label: '空闲'
      }, {
        value: 1,
        label: '占用'
      }, {
        value: -1,
        label: '停用'
      }],
      typeArr: [
      //状态数组
      {
        value: 1,
        label: '亿联'
      }, {
        value: 2,
        label: '小鱼'
      }],
      committeeValue: '',
      //所属仲裁委值
      committeeArr: [],
      equipmentArr: [],
      loading: true,
      tableData: [],
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      total: 0,
      channelType: _dictionary.dictionary.channelType,
      channelState: _dictionary.dictionary.channelState,
      sourceVisible: false,
      //弹窗显示
      temForm: {
        //数据
        name: '',
        commId: '',
        commName: '',
        state: '',
        serverSupport: '',
        meetingNumber: '',
        controlPassword: '',
        password: '',
        equipmentId: null
      },
      temFormRules: {
        name: [{
          required: true,
          message: '请输入名称'
        }],
        commId: [{
          required: true,
          message: '请选择仲裁委'
        }],
        serverSupport: [{
          required: true,
          message: '请选择渠道类型'
        }],
        state: [{
          required: true,
          message: '请选择状态'
        }]
      }
    };
  },
  components: {
    Tinymce: _Tinymce.default
  },
  created: function created() {
    var _this = this;
    this.currentPage = 1;
    this.init();
    //仲裁委员会列表
    (0, _configure.getAllCommission)().then(function (res) {
      if (res.code == 1) {
        _this.committeeArr = res.data;
      }
    });
  },
  mounted: function mounted() {},
  methods: {
    // 初始化
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _yield$getConferenceA, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _configure.getConferenceAisleList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 2:
              _yield$getConferenceA = _context.sent;
              rows = _yield$getConferenceA.rows;
              total = _yield$getConferenceA.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    //重置列表
    resetTableList: function () {
      var _resetTableList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _yield$getConferenceA2, rows, total, _yield$getConferenceA3, _rows, _total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.statevalue || this.committeeValue)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 3;
              return (0, _configure.getConferenceAisleList)({
                commId: this.committeeValue,
                state: this.statevalue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 3:
              _yield$getConferenceA2 = _context2.sent;
              rows = _yield$getConferenceA2.rows;
              total = _yield$getConferenceA2.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context2.next = 19;
              break;
            case 11:
              _context2.next = 13;
              return (0, _configure.getConferenceAisleList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 13:
              _yield$getConferenceA3 = _context2.sent;
              _rows = _yield$getConferenceA3.rows;
              _total = _yield$getConferenceA3.total;
              this.tableData = _rows;
              this.total = _total;
              this.loading = false;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function resetTableList() {
        return _resetTableList.apply(this, arguments);
      }
      return resetTableList;
    }(),
    //筛选
    screen: function () {
      var _screen = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _yield$getConferenceA4, rows, total, _yield$getConferenceA5, _rows2, _total2;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.total = 1;
              this.currentPage = 1;
              if (!(this.statevalue != null || this.committeeValue)) {
                _context3.next = 13;
                break;
              }
              _context3.next = 5;
              return (0, _configure.getConferenceAisleList)({
                commId: this.committeeValue,
                state: this.statevalue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 5:
              _yield$getConferenceA4 = _context3.sent;
              rows = _yield$getConferenceA4.rows;
              total = _yield$getConferenceA4.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context3.next = 21;
              break;
            case 13:
              _context3.next = 15;
              return (0, _configure.getConferenceAisleList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 15:
              _yield$getConferenceA5 = _context3.sent;
              _rows2 = _yield$getConferenceA5.rows;
              _total2 = _yield$getConferenceA5.total;
              this.tableData = _rows2;
              this.total = _total2;
              this.loading = false;
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function screen() {
        return _screen.apply(this, arguments);
      }
      return screen;
    }(),
    //点击 清空所有筛选条件
    clearAllConditon: function clearAllConditon() {
      this.statevalue = '';
      this.committeeValue = "";
      this.currentPage = 1;
      this.init();
    },
    // 分页事件
    handleSizeChange: function handleSizeChange(val) {
      this.pageLimit = val;
      this.resetTableList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.resetTableList();
    },
    //删除
    deleteRow: function deleteRow(val) {
      var _this2 = this;
      this.$confirm('是否删除该会议通道？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _configure.deleteAisleById)(val.id).then(function (res) {
          if (res.code == 1) {
            _this2.$message({
              message: '删除成功',
              type: 'success'
            });
            _this2.resetTableList();
          } else {
            _this2.$message({
              message: res.msg,
              type: 'error'
            });
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //修改
    edit: function edit(val) {
      var _this3 = this;
      this.sourceVisible = true;
      (0, _configure.getAisleInfoById)(val.id).then(function (res) {
        if (res.code == 1) {
          _this3.temForm = res.data;
          _this3.commSourceChange(res.data.commId);
        } else {
          _this3.$message({
            message: res.msg,
            type: 'error'
          });
        }
      });
    },
    gotoCreate: function gotoCreate() {
      this.sourceVisible = true;
      this.temForm = {
        //数据
        name: '',
        commId: '',
        commName: '',
        state: '',
        serverSupport: '',
        meetingNumber: '',
        controlPassword: '',
        password: ''
      };
    },
    submitForm: function submitForm(formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var committeeItem = _this4.committeeArr.find(function (ele) {
            return ele.id == _this4.temForm.commId;
          });
          _this4.temForm.commName = committeeItem.name;
          if (_this4.temForm.serverSupport == 1) {
            (0, _configure.saveAisleYl)(_this4.temForm).then(function (res) {
              if (res.code == 1) {
                _this4.$message({
                  message: '操作成功',
                  type: 'success'
                });
                _this4.sourceVisible = false;
                _this4.$refs[formName].resetFields();
                _this4.resetTableList();
              } else {
                _this4.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            });
          } else {
            (0, _configure.saveAisle)(_this4.temForm).then(function (res) {
              if (res.code == 1) {
                _this4.$message({
                  message: '操作成功',
                  type: 'success'
                });
                _this4.sourceVisible = false;
                _this4.$refs[formName].resetFields();
                _this4.resetTableList();
              } else {
                _this4.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    commSourceChange: function commSourceChange(commId) {
      var _this5 = this;
      if (commId) {
        (0, _configure.getEquipmentList)({
          commId: commId
        }).then(function (res) {
          if (res.code == 1) {
            _this5.equipmentArr = res.data;
          }
        });
      }
    }
  }
};
exports.default = _default;